import EntityContent from './EntityContent';

export default EntityContent;
